import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52dd7c78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "leak-view-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "selection-bar cm-ui-mb15"
}
const _hoisted_3 = {
  key: 0,
  class: "leak-level"
}
const _hoisted_4 = {
  key: 1,
  class: "leak-level optional"
}
const _hoisted_5 = ["onMouseover"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsSubscribeBar = _resolveComponent("DetailsSubscribeBar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_PatchPopover = _resolveComponent("PatchPopover")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _component_RepairDrawer = _resolveComponent("RepairDrawer")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isTerminalInfo && _ctx.terminalInfo.system_type === _ctx.TerminalType.linux)
      ? (_openBlock(), _createBlock(_component_DetailsSubscribeBar, {
          key: 0,
          class: "cm-ui-mb10",
          "linux-permission-key": _ctx.ModulePermissionKey[_ctx.AreaType.linux],
          "auth-status": _ctx.getAuthByList(_ctx.terminalInfo.auth_status, _ctx.ModulePermissionKey[_ctx.AreaType.linux]),
          "device-id": _ctx.terminalInfo.device_id,
          onAuthSuccess: _ctx.handleAuthSuccess
        }, null, 8, ["linux-permission-key", "auth-status", "device-id", "onAuthSuccess"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SearchFilterBar, {
        style: {"padding":"16px 16px 0","background-color":"var(--cm-color-card-bg)"},
        modelValue: _ctx.queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryParams) = $event)),
        "sync-search-from-field": "kb_number",
        "search-placeholder": _ctx.$t('safeProtectionModule.patchNumber'),
        "form-columns": _ctx.filterFormColumns,
        "show-search": true,
        "popover-threshold": 2,
        onSearch: _ctx.handleSearch,
        onQuery: _ctx.handleQuery,
        onReset: _ctx.handleReset
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            disabled: _ctx.selectedCount === 0,
            size: "small",
            type: "primary",
            onClick: _ctx.batchIgnore
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.batchIgnore')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            disabled: _ctx.selectedCount === 0,
            size: "small",
            type: "primary",
            class: "cm-ui-ml10",
            onClick: _ctx.batchRepair
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.batchRepairNotify')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          (_ctx.viewMode === _ctx.TableViewMode.preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                class: "cm-ui-ml10",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.viewAllLeaks')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "search-placeholder", "form-columns", "onSearch", "onQuery", "onReset"]),
      (_ctx.selectedCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('cmtable.selectedPrefix')) + " ", 1),
              _createElementVNode("a", null, _toDisplayString(_ctx.selectedCount), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('cmtable.selectedSuffix')), 1)
            ]),
            _createVNode(_component_el_button, {
              class: "btn cm-ui-ml10",
              type: "text",
              disabled: _ctx.selectedCount === 0,
              onClick: _ctx.selectCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cmtable.clearSelection')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "table-wrapper",
        style: _normalizeStyle({ height: _ctx.viewMode === _ctx.TableViewMode.full ? 'calc(100% - 120px)' : 'calc(400px - 56px)' })
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          ref: "tableRef",
          data: _ctx.tableData,
          "min-width": "100%",
          height: _ctx.viewMode === _ctx.TableViewMode.full ? '100%' : undefined,
          "tooltip-effect": "light",
          onSortChange: _ctx.handlerSort,
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "selection" }),
            _createVNode(_component_el_table_column, {
              prop: "kb_number",
              label: _ctx.$t('safeProtectionModule.patchNumber'),
              width: 200
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_PatchPopover, {
                  "patch-info": _ctx.patch_info,
                  "warn-level": scope.row.warn_level,
                  "description-fallback": _ctx.displayKbDesc(scope.row),
                  "pub-date-fallback": scope.row.kb_pub_date
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "kb_number",
                      onMouseover: ($event: any) => (_ctx.getPatchInfo(scope.row )),
                      "data-test": "kb_number"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.kb_number.includes('CVE-') ? `${scope.row.kb_number}` : `KB${scope.row.kb_number}`), 1)
                      ]),
                      _: 2
                    }, 1032, ["onMouseover"])
                  ]),
                  _: 2
                }, 1032, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "kb_pub_date",
              label: _ctx.$t('safeProtectionModule.patchPubDate'),
              width: 180
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "warn_level",
              label: _ctx.$t('safeProtectionModule.leakLevel'),
              width: 180
            }, {
              default: _withCtx((scope) => [
                (scope.row.warn_level)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('safeProtectionModule.leakHigh')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('safeProtectionModule.leakOptional')), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "kb_desc",
              label: _ctx.$t('safeProtectionModule.leakDesc')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_PatchPopover, {
                  "patch-info": _ctx.patch_info,
                  placement: "bottom",
                  "warn-level": scope.row.warn_level,
                  "description-fallback": _ctx.displayKbDesc(scope.row),
                  "pub-date-fallback": scope.row.kb_pub_date
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "patch_text",
                      onMouseover: ($event: any) => (_ctx.getPatchInfo(scope.row ))
                    }, _toDisplayString(_ctx.displayKbDesc(scope.row)), 41, _hoisted_5)
                  ]),
                  _: 2
                }, 1032, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
              ]),
              _: 1
            }, 8, ["label"]),
            (!_ctx.isTerminalInfo)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  align: "center",
                  prop: "terminal_count",
                  width: 200,
                  label: _ctx.$t('safeProtectionModule.affectedTerminals'),
                  sortable: "custom"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      type: scope.row.terminal_count && !_ctx.isTerminalInfo ? 'primary':'default',
                      onClick: _withModifiers(($event: any) => (scope.row.terminal_count && !_ctx.isTerminalInfo && _ctx.repairLeak(scope.row)), ["prevent"]),
                      class: "optional-txt"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.terminal_count), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "onClick"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('safeProtectionModule.colOperation'),
              width: "120"
            }, {
              default: _withCtx((scope) => [
                (!_ctx.isTerminalInfo)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "active_text",
                      type: "text",
                      onClick: ($event: any) => (_ctx.repairLeak(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.kb_number.includes('CVE-') ? _ctx.$t('safeProtectionModule.leakDetailBtn') : _ctx.$t('safeProtectionModule.repairLeakBtn')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  class: "active_text",
                  type: "text",
                  onClick: ($event: any) => (_ctx.ignoreLeak(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.ignoreLeakBtn')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "data", "height", "onSortChange", "onSelectionChange"])), [
          [_directive_loading, _ctx.isLoading],
          [_directive_load_more, _ctx.loadMoreData]
        ])
      ], 4),
      (_ctx.viewMode === _ctx.TableViewMode.full)
        ? (_openBlock(), _createBlock(_component_LoadMoreButton, {
            key: 1,
            loading: _ctx.isLoading,
            current: _ctx.tableData.length,
            total: _ctx.total,
            onLoadMore: _ctx.loadMoreData
          }, null, 8, ["loading", "current", "total", "onLoadMore"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      size: 1300,
      modelValue: _ctx.repairDrawer,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.repairDrawer) = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.repairLeakTitle'),
      "before-close": _ctx.handleRepairDrawerClose,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_RepairDrawer, { "current-leak": _ctx.currentItem }, null, 8, ["current-leak"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"])
  ], 64))
}